import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

import HomeIcon from "@mui/icons-material/Home";
import LightbulbIcon from "@mui/icons-material/Lightbulb";
import RateReviewIcon from "@mui/icons-material/RateReview";
import DescriptionIcon from "@mui/icons-material/Description";

import CustomForm from "../../../helper-components/form/CustomForm.jsx";
import NavigationFooter from "../../../helper-components/misc/NavigationFooter.jsx";

import HighlightRequestsTable from "./components/HighlightRequestsTable.jsx";

import { getLanguage } from "../../../config/language/language.js";

/**
 * The highlight requests page.
 */
export default function HighlightRequests(props) {
    return (
        <Container maxWidth="xl" sx={{ mt: 2, mb: 2 }}>
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <CustomForm title={getLanguage().HIGHLIGHT_REQUESTS_TITLE} subtitle={getLanguage().HIGHLIGHT_REQUESTS_SUBTITLE} icon={<LightbulbIcon />} />
                </Grid>

                <Grid item xs={12}>
                    <HighlightRequestsTable {...props} />
                </Grid>

                <NavigationFooter
                    rows={2}
                    options={[
                        {
                            path: `/database/resources`,
                            title: "Resources",
                            variant: "outlined",
                            icon: <DescriptionIcon />
                        },
                        {
                            path: `/highlights/view`,
                            title: "Highlights",
                            variant: "outlined",
                            icon: <RateReviewIcon />
                        },
                        {
                            path: `/home`,
                            title: "Home",
                            variant: "outlined",
                            icon: <HomeIcon />
                        }
                    ]}
                />
            </Grid>
        </Container>
    );
}
